export default __webpack_public_path__ + "static/media/playstation4-new.bd82a6a6.png";